module.exports = __webpack_public_path__ + "img/thumb_31.f2a7d380.jpg";